import styled from 'styled-components';
import { Card } from '../../style';

export const StyledActivityCard = styled(Card)`
  grid-column: span 12;
  margin-top: 24px;
  position: relative;
`;

export const ActivityHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;

  h2 {
    font-size: 18px;
    font-weight: 700;
    color: #1a1a1a;
    margin: 0;
  }
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

export const Legend = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #666;
  font-weight: 500;
`;

export const LegendColor = styled.div<{ color: string }>`
  width: 10px;
  height: 10px;
  border-radius: 2px;
  background-color: ${({ color }) => color};
`;


export const ChartContainer = styled.div`
  height: 320px;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const YAxis = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 40px;
  width: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  padding-right: 12px;
  color: #888;
  font-size: 12px;
  font-weight: 500;
  z-index: 1;
`;

export const GridContainer = styled.div`
  flex: 1;
  margin-left: 40px;
  position: relative;
  border-bottom: 1px solid #f0f0f0; /* Restoring the baseline as a subtle solid line */
  margin-bottom: 30px; /* Reduced space for labels to keep them tighter */
`;

export const GridLine = styled.div<{ bottom: string }>`
  position: absolute;
  left: 0;
  right: 0;
  bottom: ${({ bottom }) => bottom};
  border-top: 1px dashed #f0f0f0;
  z-index: 0;

  /* Hide the dashed line at 0 since we have a solid baseline */
  ${({ bottom }) => bottom === '0%' && 'display: none;'}
`;

export const BarsWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: space-around;
  padding: 0 20px;
  z-index: 2;
`;

export const BarGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
  position: relative;
  width: 60px;
  height: 100%;
`;

export const StackedBar = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  border-radius: 12px 12px 0 0;
  overflow: hidden;
  transition: all 0.3s ease;
  transform-origin: bottom;
`;

export const BarSegment = styled.div<{ height: string; color: string; active?: boolean }>`
  width: 100%;
  height: ${({ height }) => height};
  background-color: ${({ color, active }) => active ? color : `${color}80`}; /* Reduced fade to 50% opacity */
  transition: all 0.3s ease;
`;

export const XAxis = styled.div`
  position: absolute;
  bottom: 0;
  left: 40px;
  right: 0;
  height: 30px;
  display: flex;
  justify-content: space-around;
  padding: 0 20px;
  z-index: 1;
`;

export const XLabel = styled.div`
  color: #888;
  font-size: 13px;
  font-weight: 700;
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Tooltip = styled.div<{ left: number; top: number; visible: boolean }>`
  position: absolute;
  left: ${({ left }) => left}px;
  top: ${({ top }) => top}px;
  background: #f5f5f5;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.12);
  z-index: 100;
  pointer-events: none;
  opacity: ${({ visible }) => visible ? 1 : 0};
  transform: translate(0, -100%) translateY(-10px);
  transition: opacity 0.2s, transform 0.2s;
  min-width: 140px;
  border: 1px solid #eee;

  h4 {
    margin: 0 0 12px 0;
    font-size: 13px;
    color: #333;
    text-transform: uppercase;
    font-weight: 700;
  }
`;

export const TooltipRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
  font-size: 14px;
  color: #555;
  font-weight: 500;

  &:last-child {
    margin-bottom: 0;
  }

  .label-group {
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;

export const TooltipDot = styled.div<{ color: string }>`
  width: 8px;
  height: 8px;
  border-radius: 2px;
  background-color: ${({ color }) => color};
`;
